import React, { useState, useEffect } from 'react';

const LOADING_MESSAGES = [
  "납땜 인두 예열 중... 🔥",
  "상상력을 조립하고 있어요 🧩",
  "3D 프린터 노즐 닦는 중 ⚙️",
  "아두이노 스케치 업로드 중 💻",
  "센서 감도 조절 중 📡",
  "메이커들의 아이디어 수집 중 💡",
  "박스 테이프 뜯는 소리... 📦"
];

const LoadingScreen: React.FC = () => {
  const [message, setMessage] = useState(LOADING_MESSAGES[0]);

  useEffect(() => {
    // 2초마다 메시지 랜덤 변경
    const interval = setInterval(() => {
      const randomIdx = Math.floor(Math.random() * LOADING_MESSAGES.length);
      setMessage(LOADING_MESSAGES[randomIdx]);
    }, 2000);

    // 로고 애니메이션 (anime.js가 window에 로드되어 있다고 가정)
    if (window.anime) {
      window.anime({
        targets: '.loading-logo',
        translateY: [-20, 0],
        rotate: [0, 10, -10, 0],
        scale: [1, 1.1, 1],
        duration: 1500,
        loop: true,
        easing: 'easeInOutQuad'
      });
    }

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center p-4">
      <div className="relative mb-8">
        <div className="loading-logo w-20 h-20 bg-indigo-600 rounded-2xl flex items-center justify-center text-white font-black text-4xl shadow-2xl shadow-indigo-200 transform">
          M
        </div>
        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-16 h-2 bg-black/10 rounded-full blur-sm animate-pulse"></div>
      </div>
      
      <h3 className="text-xl font-black text-gray-900 mb-2 italic animate-pulse">
        MAKER STORY
      </h3>
      
      <div className="h-8 flex items-center justify-center overflow-hidden">
        <p className="text-sm font-bold text-gray-500 animate-in slide-in-from-bottom-2 fade-in duration-500 key={message}">
          {message}
        </p>
      </div>

      <div className="mt-8 w-48 h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div className="h-full bg-indigo-600 rounded-full w-1/3 animate-[loading-bar_1.5s_infinite_ease-in-out]"></div>
      </div>

      <style>{`
        @keyframes loading-bar {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(0%); width: 60%; }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
